import {utils_tool} from '@/tool';
import React from 'react'
import moment from "moment";

let {$$, checkStrLength} = utils_tool;

//配置项
let componentName = 'storeReportRecord'


const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "区域",
    name: "zone",
    tableItem: {
      width: 200
    },
    searchItem: {}
  },
  {
    title: "经销商名称",
    name: "dealerName",
    tableItem: {
      width: 200
    },
    searchItem: {}
  },
  {
    title: "经销商代码",
    name: "dealerCode",
    tableItem: {
      width: 200
    },
    searchItem: {}
  },
  {
    title: '报告发布时间',
    name: 'reportReleaseTime',
    tableItem: {
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: '数据截止时间',
    name: 'dataEndTime',
    tableItem: {
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  }
];

const templateConfig = (id, _this, data) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          collapse: false,
          buttonSort: [],
          buttons: []
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          loading: false,
        }
      }
    }
  };
};

const apis = (record) => {
  const {id} = record;
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@pageList`,
        apiParams: {pageNum: 1, pageSize: 10, reportId: id}
      }
    }
  };
};

let reduxTemplateCofig = (args) => {
  const {record} = args;
  return {
    apis: apis(record),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
